/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FilterLogicalOperator,
    FilterLogicalOperatorFromJSON,
    FilterLogicalOperatorFromJSONTyped,
    FilterLogicalOperatorToJSON,
    SortingDto,
    SortingDtoFromJSON,
    SortingDtoFromJSONTyped,
    SortingDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetAllContactPersonsQuery
 */
export interface GetAllContactPersonsQuery {
    /**
     * 
     * @type {boolean}
     * @memberof GetAllContactPersonsQuery
     */
    excludeContractorContacts?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAllContactPersonsQuery
     */
    excludeTownContacts?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetAllContactPersonsQuery
     */
    page?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetAllContactPersonsQuery
     */
    pageSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetAllContactPersonsQuery
     */
    skip?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllContactPersonsQuery
     */
    take?: number;
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof GetAllContactPersonsQuery
     */
    filterLogicalOperator?: FilterLogicalOperator;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetAllContactPersonsQuery
     */
    filterKeys?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<SortingDto>}
     * @memberof GetAllContactPersonsQuery
     */
    sortings?: Array<SortingDto> | null;
}

export function GetAllContactPersonsQueryFromJSON(json: any): GetAllContactPersonsQuery {
    return GetAllContactPersonsQueryFromJSONTyped(json, false);
}

export function GetAllContactPersonsQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllContactPersonsQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'excludeContractorContacts': !exists(json, 'excludeContractorContacts') ? undefined : json['excludeContractorContacts'],
        'excludeTownContacts': !exists(json, 'excludeTownContacts') ? undefined : json['excludeTownContacts'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'skip': !exists(json, 'skip') ? undefined : json['skip'],
        'take': !exists(json, 'take') ? undefined : json['take'],
        'filterLogicalOperator': !exists(json, 'filterLogicalOperator') ? undefined : FilterLogicalOperatorFromJSON(json['filterLogicalOperator']),
        'filterKeys': !exists(json, 'filterKeys') ? undefined : json['filterKeys'],
        'sortings': !exists(json, 'sortings') ? undefined : (json['sortings'] === null ? null : (json['sortings'] as Array<any>).map(SortingDtoFromJSON)),
    };
}

export function GetAllContactPersonsQueryToJSON(value?: GetAllContactPersonsQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'excludeContractorContacts': value.excludeContractorContacts,
        'excludeTownContacts': value.excludeTownContacts,
        'page': value.page,
        'pageSize': value.pageSize,
        'skip': value.skip,
        'take': value.take,
        'filterLogicalOperator': FilterLogicalOperatorToJSON(value.filterLogicalOperator),
        'filterKeys': value.filterKeys,
        'sortings': value.sortings === undefined ? undefined : (value.sortings === null ? null : (value.sortings as Array<any>).map(SortingDtoToJSON)),
    };
}


